@if (locationData?.original_location) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Ubicazione</h3>
    <dl class="sheet-facts">
      <div>
        <dt>Ubicazione originaria</dt>
        <dd>{{ locationData.original_location }}</dd>
      </div>
    </dl>
  </section>
}

@for (item of locationData?.museumInventory; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Inventario di museo o soprintendenza {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.number) {
        <div>
          <dt>Numero</dt>
          <dd>{{ item.number }}</dd>
        </div>
      }
      @if (item?.date) {
        <div>
          <dt>Data</dt>
          <dd>{{ item.date }}</dd>
        </div>
      }
      @if (item?.location) {
        <div>
          <dt>Collocazione</dt>
          <dd>{{ item.location }}</dd>
        </div>
      }
    </dl>
  </section>
}
